import { AbilityBuilder } from '@casl/ability'

export default (user, role) => {
  // const subjectName = subject =>
  //   !subject || typeof subject === 'string' ? subject : subject.type
  const subjectName = (subject) =>
    !subject || typeof subject === 'string'
      ? subject
      : subject.__typename.toLowerCase()

  return AbilityBuilder.define({ subjectName }, (can) => {
    /**
     * Global permissions
     */

    // Comments
    can(['read', 'create'], 'comment')
    can(['delete', 'update'], 'comment', { 'creator.id': user.id })

    /**
     * Role based permissions
     */
    switch (role) {
      case 'manager':
        // comments
        can(['delete'], 'comment')

        // Settings
        can(['manage'], 'settings')

        // Task
        can(['delete'], 'task')

        // Payments
        can(['manage'], 'payment')

        can(['update-statuts-rejected', 'update-statuts-done'], 'procedure')

        break
      default:
        break
    }

    if (user.isDpo) {
      can(['delete'], 'task')
      can(['update-statuts-rejected', 'update-statuts-done'], 'procedure')
    }
  })
}
